<template>
  <div class="modal-cademi">
    <hr />
    <bp-select
      v-model="form.product_id"
      id="product-select"
      label="Nome do produto"
      class="mb-3"
      placeholder="Selecionar produto"
      :disabled="isEdit"
      :errors="errors.product_id"
      :options="products.map(({ id, name }) => ({ id, name }))"
      required
    />

    <div class="row">
      <div class="col-lg-6">
        <bp-input
          v-model="form.description"
          id="description"
          label="Descrição da integração (Opcional)"
          placeholder="Digite a descrição da integração"
          :errors="errors.description"
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          v-model="form.url"
          id="url"
          label="URL de postback"
          placeholder="Digite a URL de postback"
          :errors="errors.url"
          required
        />
      </div>
    </div>

    <div class="submit-buttons">
      <bp-button
        color="neutral"
        variant="filled-1"
        label="Cancelar"
        @click="$emit('close')"
      />
      <bp-button
        label="Integrar"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(
        ["product_id", "url", "status", "description"],
        this.integrationToEdit
      )
    };
  },
  computed: {
    isValid() {
      return this.form.product_id && this.form.url;
    }
  }
};
</script>
